import { observer } from 'mobx-react-lite';

import LanguagePublishedModal from './LanguagePublishedModal';

function PublishedModal({ closeModal, job, t, redirectOnSuccess = true }) {
  return (
    <LanguagePublishedModal
      closeModal={closeModal}
      job={job}
      t={t}
      redirectOnSuccess={redirectOnSuccess}
    />
  );
}

export default observer(PublishedModal);
